import { useEffect } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { CampaignStatusEnum } from 'src/Types/campaigns'
import { campaignsList } from 'src/Router/routes'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { useGetSpotifyCampaignStatusQuery } from 'src/Redux/spotifyCampaignStatusApi'

const notForScheduleCampaignStatuses = [
  CampaignStatusEnum.RUNNING,
  CampaignStatusEnum.ENDED,
  CampaignStatusEnum.STOPPED,
]

export const useCheckSpotifyCampaignStatus = (): void => {
  const { search } = useCustomSearchParams()
  const paymentStatus = search.get('paymentStatus')

  const params = useParams()
  const navigate = useNavigate()

  const isSuccessPageVisible = paymentStatus === 'success'
  const campaignId = Number(params.number)

  const { data, isError } = useGetSpotifyCampaignStatusQuery(campaignId)

  useEffect(() => {
    if (isError) {
      navigate(campaignsList)
      return
    }

    if (!data) {
      return
    }

    const campaignDetailsUrl = `/campaigns/view/${campaignId}`
    const isSchedulePassed = notForScheduleCampaignStatuses.includes(
      data.status,
    )
    const isScheduledStatus = data.status === CampaignStatusEnum.SCHEDULED

    if ((isScheduledStatus || isSchedulePassed) && !isSuccessPageVisible) {
      navigate(campaignDetailsUrl)
    }
  }, [campaignId, data, isError, isSuccessPageVisible, navigate])
}
